// extracted by mini-css-extract-plugin
module.exports = {"numero":"ListeCommandes_numero__2qd2E","nom":"ListeCommandes_nom__3Xtlz","com":"ListeCommandes_com__3uou6","produits":"ListeCommandes_produits__bsLmq"};